<script setup lang="ts">
import BaseToast from '@/components/common/BaseToast.vue'
import { useToast } from '@/composables/useToast'

/** Mounted once, globally, in App.vue — every notify()/success()/error() call from anywhere renders here. */
const { toasts, dismiss } = useToast()
</script>

<template>
  <Teleport to="body">
    <div class="pointer-events-none fixed inset-x-0 top-4 z-60 flex flex-col items-center gap-2 px-4">
      <TransitionGroup
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="-translate-y-2 opacity-0"
        leave-active-class="transition duration-150 ease-in"
        leave-to-class="opacity-0"
      >
        <div v-for="toast in toasts" :key="toast.id" class="pointer-events-auto w-full max-w-sm">
          <BaseToast :message="toast.message" :variant="toast.variant" @dismiss="dismiss(toast.id)" />
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped></style>
